import { baseApi, ENDPOINTS } from '@/shared/api';

import type { PatternWatchlist } from '../model/types/pattern-watchlist';

const patternWatchlistApi = baseApi
    .enhanceEndpoints({
        addTagTypes: ['PatternWatchlist'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getPatternWatchlists: build.query<Array<PatternWatchlist>, void>({
                query: () => ENDPOINTS.patternWatchlist.getAll,
                providesTags: ['PatternWatchlist'],
            }),
            createPatternWatchlist: build.mutation<
                PatternWatchlist,
                Omit<PatternWatchlist, 'id'>
            >({
                query: (watchlist) => ({
                    url: ENDPOINTS.patternWatchlist.create,
                    method: 'POST',
                    body: watchlist,
                }),
                invalidatesTags: ['PatternWatchlist'],
            }),
            updatePatternWatchlist: build.mutation<void, PatternWatchlist>({
                query: (watchlist) => ({
                    url: ENDPOINTS.patternWatchlist.update(watchlist.id),
                    method: 'PUT',
                    body: watchlist,
                }),
                invalidatesTags: ['PatternWatchlist'],
            }),
            deletePatternWatchlist: build.mutation<void, number>({
                query: (id) => ({
                    url: ENDPOINTS.patternWatchlist.delete(id),
                    method: 'DELETE',
                }),
                invalidatesTags: ['PatternWatchlist'],
            }),
        }),
    });

export const {
    useGetPatternWatchlistsQuery,
    useCreatePatternWatchlistMutation,
    useUpdatePatternWatchlistMutation,
    useDeletePatternWatchlistMutation,
} = patternWatchlistApi;

export const getPatternWatchlistsFulfilled =
    patternWatchlistApi.endpoints.getPatternWatchlists.matchFulfilled;
